import { maxBreakpoints, minBreakpoints, pulse, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing;
export var card = /*#__PURE__*/css(["height:100%;position:relative;"]);
export var copy = /*#__PURE__*/css(["display:flex;flex-direction:column;margin-top:", ";", ";"], pxToRem(20), mediaQuery({
  min: minBreakpoints.XL
}, css(["flex-direction:row;justify-content:space-between;"])));
export var mainSection = /*#__PURE__*/css(["width:100%;", ";"], mediaQuery({
  min: minBreakpoints.XL
}, css(["width:60%;"])));
export var labelMargin = /*#__PURE__*/css(["margin-bottom:", ";"], pxToRem(spacing.sm));
export var imagePlaceholder = /*#__PURE__*/css(["width:100%;padding-top:100%;border-radius:", ";", ";", ""], pxToRem(10), mediaQuery({
  min: minBreakpoints.L
}, css(["border-radius:", ";"], pxToRem(20))), pulse);
export var mobileImageCropEven = /*#__PURE__*/css(["", ";"], mediaQuery({
  max: maxBreakpoints.S
}, css(["border-radius:0 ", " ", " 0;"], pxToRem(10), pxToRem(10))));
export var mobileImageCropOdd = /*#__PURE__*/css(["", ""], mediaQuery({
  max: maxBreakpoints.S
}, css(["&:nth-child(odd){border-radius:", " 0 0 ", ";}"], pxToRem(10), pxToRem(10))));
export var line = /*#__PURE__*/css(["width:100%;height:", ";margin:0 0 ", "px 0;border-radius:", ";", ""], pxToRem(20), spacing.xs, pxToRem(6), pulse);